import Tab from './Tab';
import TabContent from './TabContent';
import TabContentProgress from './TabContentProgress';
import TabPanel from './TabPanel';

export default TabPanel;
export { Tab, TabContent, TabContentProgress };
